import React, { Fragment } from 'react';
import classNames from 'classnames';

import map from 'lodash/map';

import {
  getJobFeedFieldRenderForType,
  makeJobFeedItemFieldClassName,
  makeJobFeedItemClassNames
} from './renderers.jsx';

const renderDivBase = ({ fieldName, className, label, content, index })=> 
  <div key={index} className={classNames('job-feed-item-field', makeJobFeedItemFieldClassName(className || label || fieldName))}>
    <span className="jfi-field-label-text">
      {label}
    </span><span className="jfi-field-label-sep">
    </span>
    <span className="jfi-field-content">
      {content}
    </span>
  </div>;


const JobFeedDivs = ({ jobs, displayFields }) => (
  <Fragment>
    {
      map(jobs, (job, jindex)=>
        <div key={jindex} className={classNames('job-feed-item', makeJobFeedItemClassNames(job, displayFields.itemCssClassFields))}>
          {
            map(displayFields.fields, ({ type, ...displayInfo }, index)=>
              getJobFeedFieldRenderForType(type)({
                render: renderDivBase,
                index: index,
                datum: job,
                ...displayInfo
              })
            )
          }
        </div>
      )
    }
  </Fragment>
);

export default JobFeedDivs;